// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"app-pages-Ingredient-Category-CategoryDetail-CategoryForm-__CategoryForm___dvHo0","content-wrapper":"app-pages-Ingredient-Category-CategoryDetail-CategoryForm-__CategoryForm___2cDOh"};


//////////////////
// WEBPACK FOOTER
// ./app/pages/Ingredient/Category/CategoryDetail/CategoryForm/CategoryForm.css
// module id = 2102
// module chunks = 0